function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: [{ title: 'Date', filter: 'dateFull' }, { title: 'Period', filter: 'datePeriod' }, 'Description', 'Created By', { title: 'Created Date', filter: 'dateFull' }, 'Approved By', { title: 'Approved Date', filter: 'dateFull' }, 'Printed By', { title: 'Printed Date', filter: 'dateFull' }, 'Checks'],
            fields: ['check_date', 'check_period', 'description', 'create_user.full_name', 'created_at', 'approve_user.full_name', 'approved_at', 'print_user.full_name', 'printed_at', 'checks.length'],
            items: []
        };
    },
    created: function created() {

        var $el = this;

        Event.$on('add-payment', function () {
            Event.$emit('ap-add-payment');
        });

        Event.$on('update-payment', function (item, idx) {
            Event.$emit('ap-edit-payment', item);
        });

        Event.$on('remove-payment', function (item, idx) {
            if (!item.printed_at) {
                Event.$emit('confirm-delete', item, '/prototype/accounting/accounts-payable/payment/delete', 'delete-payment');
            } else {
                Event.$emit('show-small-modal', 'Payment Cannot Be Deleted');
            }
        });

        Event.$on('delete-payment', this.deletePayment);

        Event.$on('view-payment', this.viewPayment);

        Event.$on('refresh-payments', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            $el.load(offset, search, sort, order, isDate);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('add-payment');
        Event.$off('update-payment');
        Event.$off('remove-payment');
        Event.$off('delete-payment');
        Event.$off('view-payment');
        Event.$off('refresh-payments');
    },


    methods: {
        deletePayment: function deletePayment(item) {
            var $el = this;
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
        },
        viewPayment: function viewPayment(item) {
            var $el = this;
            axios.get('/prototype/accounting/accounts-payable/payments/' + item.id).then(function (response) {
                $el.item = response.data;
                Event.$emit('show-flyout', 'Payment Details', null, 'ap-payment-details', $el.item);
            });
        },
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var self = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };

            axios.post('/prototype/accounting/accounts-payable/payments/fetch', data).then(function (response) {

                offset !== 0 ? self.items = [].concat(_toConsumableArray(self.items), _toConsumableArray(response.data)) : self.items = response.data;

                Event.$emit('data-table-loaded');
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/payments/PaymentList.vue
// module id = jz8l
// module chunks = 0 1